import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'ui-skeleton-loading',
    templateUrl: './skeleton-loading.component.html',
    styleUrls: ['./skeleton-loading.component.scss'],
    standalone: false
})
export class SkeletonLoadingComponent {
  @Input('p-width') width: number;
  @Input('p-height') height: number;
  @Input('p-circle') circle: boolean;
  @Input('p-margin-bottom') marginBottom: number = 0;

  get style() {
    return {
      'width.px': this.width,
      'height.px': this.height,
      'border-radius': this.circle ? '50%' : 'none',
      'margin-bottom.px': this.marginBottom,
    };
  }
}